// extracted by mini-css-extract-plugin
export default {"cont":"index_cont_-Sd3N","name":"index_name_-kp8s"};